export default __webpack_public_path__ + "static/media/InvestSuccess.711b3567.svg";